import styled from "@emotion/styled";
import { css } from "@emotion/react";
import {
    mediaQuery,
    breakpoints,
    colors,
    gutterSizes,
    fontSizes,
    fontWeights,
} from "@gumtree/ui-library/src/base/theme";

export const searchFiltersContainerCss = (theme, isNoSearchResults) => css`
    margin-right: ${gutterSizes.base};

    & > div {
        width: 0;
    }

    .icon {
        color: ${theme ? theme.palette.secondary.mainContrastText : colors.bark80};
        font-size: ${fontSizes.large};
    }

    .button {
        .icon {
            color: ${theme ? theme.palette.secondary.mainContrastText : colors.bark80};
            font-weight: ${fontWeights.normal};
        }
    }

    ${isNoSearchResults && `margin: 0;`}
`;

export const saveSearchButtonCss = (
    theme: any,
    hasSearchBeenSaved?: boolean,
    isNoSearchResults?: boolean
) => css`
    && {
        border-color: ${theme.palette.secondary.mainContrastText};
        border-radius: 4px;
        height: 38px;

        ${mediaQuery.until(breakpoints.xsmall)} {
            ${isNoSearchResults &&
            ` 
            height: 46px;
            width: 100%;
            display: flex;
            justify-content: center;
        `}
        }

        ${mediaQuery.until(breakpoints.msmall)} {
            ${!isNoSearchResults &&
            `  
            .icon {
            display: none;
        }
        `}
        }

        &:hover {
            background: ${theme.palette.secondary.dark};
            color: ${theme.palette.secondary.darkContrastText};
        }
        &:active {
            border: 1px solid ${colors.bark40};
        }

        svg {
            circle {
                stroke: ${colors.bark80};
            }

            ${!isNoSearchResults && mediaQuery.until(breakpoints.msmall)} {
                .icon {
                    display: none;
                }
            }
        }

        ${hasSearchBeenSaved &&
        `
        cursor: default;
        &:hover {
            background: ${theme.palette.secondary.dark};
        }
        `}

        ${hasSearchBeenSaved &&
        `
        background: ${theme.palette.secondary.dark};
        `}
    }
`;

export const FullButtonLabel = styled.div`
    ${mediaQuery.until(breakpoints.medium)} {
        display: none;
    }
`;

export const ShortButtonLabel = styled.div`
    ${mediaQuery.from(breakpoints.medium)} {
        display: none;
    }
`;
